import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { publicAssetUrl } from "../../lib/adminApi";
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function AlumniDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/api/alumni/${slug}`).then((r) => r.json()).then((d) => setItem(d?.id ? d : null)).catch(() => setItem(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <main className="p-10">Loading alumni story...</main>;
  if (!item) return <main className="p-10"><p>Alumni story not found.</p><Link className="font-bold text-emerald-700" to="/alumni">Back to alumni</Link></main>;

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-12">
      <article className="mx-auto max-w-5xl overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-slate-200">
        <div className="grid md:grid-cols-[360px_1fr]">
          <div className="bg-slate-100">
            {item.photo_url ? <img src={publicAssetUrl(item.photo_url)} alt={item.full_name} className="h-full min-h-[420px] w-full object-cover" /> : <div className="flex min-h-[420px] items-center justify-center text-7xl font-black text-emerald-700">{item.full_name?.charAt(0)}</div>}
          </div>
          <div className="p-8 md:p-10">
            <Link to="/alumni" className="font-bold text-emerald-700">← Back to alumni</Link>
            <h1 className="mt-6 text-4xl font-black text-slate-950">{item.full_name}</h1>
            <p className="mt-2 text-lg font-bold text-emerald-700">{item.current_position || item.programme}</p>
            <div className="mt-6 grid gap-3 text-sm text-slate-700 md:grid-cols-2">
              <p><b>Programme:</b> {item.programme || "N/A"}</p><p><b>Graduation:</b> {item.graduation_year || "N/A"}</p>
              <p><b>Organization:</b> {item.organization || "N/A"}</p><p><b>Location:</b> {item.location || "N/A"}</p>
            </div>
            {item.achievement && <div className="mt-8 rounded-2xl bg-yellow-50 p-5 font-semibold text-yellow-900">{item.achievement}</div>}
            <div className="mt-8 whitespace-pre-line text-base leading-8 text-slate-700">{item.story || "No story details yet."}</div>
            {item.linkedin_url && <a href={item.linkedin_url} target="_blank" rel="noopener noreferrer" className="mt-8 inline-block rounded-xl bg-emerald-700 px-5 py-3 font-bold text-white">View LinkedIn / Profile</a>}
          </div>
        </div>
      </article>
    </main>
  );
}
